import { isValidTimeFormat, isEndTimeGreater } from "../services/timeFormat";

/**
 * Factory function to create time validation effect handler
 * @param {Object} params - Parameters object
 * @param {string} params.startTimeManual24 - Start time in 24hr format
 * @param {string} params.endTimeManual24 - End time in 24hr format
 * @param {Object} params.eventDetails - Event details object
 * @param {Function} params.setUManualFormatedTimeError - Setter for formatted time error
 * @param {Function} params.setUManualEndTimeError - Setter for end time error
 * @returns {Function} Validation function
 */
export const createTimeValidationHandler = ({
  startTimeManual24,
  endTimeManual24,
  eventDetails,
  setUManualFormatedTimeError,
  setUManualEndTimeError,
}) => {
  return () => {
    if (eventDetails?.start && eventDetails?.end) {
      return;
    }

    if (
      !isValidTimeFormat(startTimeManual24) ||
      !isValidTimeFormat(endTimeManual24)
    ) {
      setUManualFormatedTimeError(true);
    }
    if (isEndTimeGreater(startTimeManual24, endTimeManual24)) {
      setUManualFormatedTimeError(false);
      setUManualEndTimeError(false);
    } else {
      setUManualFormatedTimeError(true);
      setUManualEndTimeError(true);
    }
  };
};
